import IconAlert from "components/common/IconAlert";

export default function SuccessMessage({ message, setShow }) {

    return (
        <IconAlert variant="success" dismissible onClose={() => setShow(false)}>
            <p className="mb-0">{message}</p>
        </IconAlert>
    );
}